const config = {
  REGISTER_AVAILABLE: true,
  REGISTER_AVAILABLE_FORM: true,
  ANNIVERSARY_AVAILABLE: false,
  HOOKIE_AVAILABLE: false,
  CHRISTMAS_DINNER_AVAILABLE: false,
  CHRISTMAS_DINNER_2025_AVAILABLE: true,
  CHRISTMAS_DINNER_2026_AVAILABLE: true,

  LIMIT_CHRISTMAS_DINNER: 62,
  LIMIT_CHRISTMAS_DINNER_2025: 120,
  LIMIT_CHRISTMAS_DINNER_2026: 150,

  URL_FIREBASE_STORAGE: 'https://firebasestorage.googleapis.com/v0/b/lechuzas-celestes.appspot.com/o/',

  SEASON: '2026-2027',

  FORM_ACTIVATION_DATE: '2026-06-28T19:45:00',
  FORM_DEACTIVATION_DATE: '2026-07-13T00:00:00',
  FORM_COMPLETE_BLOCK_DATE: '2026-08-31T23:59:59',

  FORM_CHRISTMAS_DINNER_2025_DEACTIVATION_DATE: '2025-12-08T23:59:00',

  CHRISTMAS_DINNER_2026_DATE: '2026-12-12T21:45:00',
  CHRISTMAS_DINNER_2026_DETAILS: 'ás 21:45h no Hotel Talaso Atlántico (Baiona)',
  CHRISTMAS_DINNER_2026_BANNER: '/img/cea-nadal-2026.jpeg?v=2',
  CHRISTMAS_DINNER_2026_PRICE_ADULT: 45,
  CHRISTMAS_DINNER_2026_PRICE_MINOR: 35,
  // Hotel Talaso Atlántico (Baiona): a votación só deixa votar a quen está a menos deste radio
  CHRISTMAS_DINNER_2026_VENUE_LAT: 42.1016144,
  CHRISTMAS_DINNER_2026_VENUE_LNG: -8.89635,
  CHRISTMAS_DINNER_2026_VOTING_RADIUS_METERS: 1000,
  FORM_CHRISTMAS_DINNER_2026_DEACTIVATION_DATE: '2026-11-10T23:59:00',

  HOTEL_URL: 'https://www.talasoatlantico.com/es/',
  HOTEL_MAPS_URL: 'https://maps.app.goo.gl/3h3NP51cVWg7fGHZ8',
  HOTEL_DISCOUNT_PERCENT: 10,
  HOTEL_DISCOUNT_CODE: 'LECHUZAS',

  IBAN: 'ES87 0182 5334 9102 0152 1505',
  EMAIL: 'lechuzascelestes@gmail.com',
  SITE_URL: 'https://formularios.lechuzascelestes.com',

  ADMIN_PASSWORD: 'l3chuz4s-c3l3st3s-1923',

  CLOUDINARY_CLOUD_NAME: 'duythdn1f',
  CLOUDINARY_UPLOAD_PRESET: 'lechuzas-membership'
}

export default config
